import { render, staticRenderFns } from "./ReplacedQR.vue?vue&type=template&id=0a013770&scoped=true"
import script from "./ReplacedQR.vue?vue&type=script&lang=js"
export * from "./ReplacedQR.vue?vue&type=script&lang=js"
import style0 from "./ReplacedQR.vue?vue&type=style&index=0&id=0a013770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a013770",
  null
  
)

export default component.exports